import { Alert, AlertDescription } from '@1trading/react';

interface WarningAlertsProps {
  warnings: readonly string[];
}

export const WarningAlerts = ({ warnings }: WarningAlertsProps) => (
  <>
    {warnings.map((warning) => (
      <Alert className="border-amber-500/40 bg-amber-500/10 text-amber-600 dark:text-amber-500" key={warning}>
        <AlertDescription className="text-inherit">{warning}</AlertDescription>
      </Alert>
    ))}
  </>
);
WarningAlerts.displayName = 'WarningAlerts';
